import {orderErrorCodes} from "../shared-types/orderErrorCodes";

export const pickErrorCodes = (predicate: (key: string) => boolean): Record<string, string> => {
  return Object.keys(orderErrorCodes).filter(predicate).reduce((reasons, key) => ({
    ...reasons,
    [key]: (orderErrorCodes as any)[key],
  }), {});
}
